import React from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import HR from '../Components/HR'
import { frontData } from '../Data/data';

const Front = () => {
  return (
    <Container role="main" className="content" fluid>
      <Row className="w-100 justify-content-center m-auto">
        <Col lg={6} xl={3} className="textSection">
          <Card border='dark' className="h-100" >
            <Card.Body className="">
              <Card.Title className="pb-2">{frontData.header}</Card.Title>
              <HR />
              <Card.Text className="pb-2">{frontData.text1}</Card.Text>
              <Card.Text className="pb-2">{frontData.text2}</Card.Text>
              <Card.Text className="pb-2">{frontData.text3}</Card.Text>
              <Card.Text className="text-center m-auto"><Link to={frontData.link1} title="Aloita itsearviointimittarin käyttö" className="btn mainButton w-50">{frontData.button1}</Link></Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3} className="d-none d-xl-flex">
            <Image src="/images/ng_x_etu.webp" alt="Tervetuloa käyttämään itsearviointimittaria" className="w-100"  />
        </Col>
      </Row>
    </Container>
  );
};

export default Front;